import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import AppLayout from "@/components/AppLayout";
import { Toaster } from "@/components/ui/sonner";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import EntityPage from "@/components/EntityPage";
import Viaggi from "@/pages/Viaggi";
import Listini from "@/pages/Listini";
import Prefatture from "@/pages/Prefatture";
import Azienda from "@/pages/Azienda";
import Scadenzario from "@/pages/Scadenzario";
import Utenti from "@/pages/Utenti";
import AuditLog from "@/pages/AuditLog";

const Page = ({ children, adminOnly }) => (
  <ProtectedRoute adminOnly={adminOnly}>
    <AppLayout>{children}</AppLayout>
  </ProtectedRoute>
);

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/" element={<Page><Dashboard /></Page>} />
          <Route path="/viaggi" element={<Page><Viaggi /></Page>} />
          <Route path="/listini" element={<Page><Listini /></Page>} />
          <Route path="/prefatture" element={<Page><Prefatture /></Page>} />
          <Route path="/azienda" element={<Page adminOnly><Azienda /></Page>} />
          <Route path="/clienti" element={<Page><EntityPage entity="clienti" /></Page>} />
          <Route path="/subvettori" element={<Page><EntityPage entity="subvettori" /></Page>} />
          <Route path="/localita" element={<Page><EntityPage entity="localita" /></Page>} />
          <Route path="/prodotti" element={<Page><EntityPage entity="prodotti" /></Page>} />
          <Route path="/veicoli" element={<Page><EntityPage entity="veicoli" /></Page>} />
          <Route path="/autisti" element={<Page><EntityPage entity="autisti" /></Page>} />
          <Route path="/scadenzario/mezzi" element={<Page><Scadenzario entityType="veicolo" /></Page>} />
          <Route path="/scadenzario/autisti" element={<Page><Scadenzario entityType="autista" /></Page>} />
          <Route path="/utenti" element={<Page adminOnly><Utenti /></Page>} />
          <Route path="/audit" element={<Page adminOnly><AuditLog /></Page>} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster richColors position="top-right" />
    </AuthProvider>
  );
}

export default App;
